import { Component, contentChild, input } from '@angular/core';
import { NttNavItemIcon } from './nav-item-icon';

@Component({
  selector: 'a[nttNavItem], button[nttNavItem]',
  templateUrl: './nav-item.html',
  styleUrl: './nav-item.scss',
  host: {
    '[class.ntt-nav-item--current]': 'current()',
  },
})
export class NttNavItem {
  current = input(false);
  icon = contentChild(NttNavItemIcon);
}
